import { createSlice } from '@reduxjs/toolkit';
import { EnrollmentSteps } from '../../constant/constant';
export interface EnrollmentState {
  isUpdatingEnrollmentInfo: boolean;
  isCompletingEnrollment: boolean;
  enrollmentStep: EnrollmentSteps;
}

const initialState: EnrollmentState = {
  isUpdatingEnrollmentInfo: false,
  isCompletingEnrollment: false,
  enrollmentStep: EnrollmentSteps.ENROLLMENT_CONTACT_INFO
};

export const enrollmentSlice = createSlice({
  name: 'enrollment',
  initialState,
  reducers: {
    updateEnrollmentStart: (state) => {
      state.isUpdatingEnrollmentInfo = true;
    },
    updateEnrollmentSuccess: (state) => {
      state.isUpdatingEnrollmentInfo = false;
    },
    updateEnrollmentFailure: (state) => {
      state.isUpdatingEnrollmentInfo = false;
    },
    resetEnrollmentStatus: (state) => {
      state.isUpdatingEnrollmentInfo = false;
    },
    updateEnrollmentComplete: (state) => {
      state.isCompletingEnrollment = true
    },
    updateEnrollmentCompleteSuccess: (state) => {
      state.isCompletingEnrollment = false;
    },
    updateEnrollmentCompleteFailure: (state) => {
      state.isCompletingEnrollment = false;
    },
    resetEnrollmentCompleteStatus: (state) => {
      state.isCompletingEnrollment = false;
    },
    setEnrollmentStatus: (state, action) => {
      state.enrollmentStep = action.payload;
    },
  },
});

export const {
  updateEnrollmentStart,
  updateEnrollmentSuccess,
  updateEnrollmentFailure,
  resetEnrollmentStatus,
  updateEnrollmentComplete,
  updateEnrollmentCompleteSuccess,
  updateEnrollmentCompleteFailure,
  resetEnrollmentCompleteStatus,
  setEnrollmentStatus
} = enrollmentSlice.actions;

export default enrollmentSlice.reducer;